<template>
  <!-- Início Wrapper -->
  <div class="wrapper bg-login-main">
    <!-- Início Página Esqueci a Senha -->
    <div class="m-account-w">
      <div class="m-account">
        <div class="row no-gutters">
          <div class="col-md-6">
            <!-- Início Textos Esqueci a Senha -->
            <div class="m-account--content-w bg-login-right">
              <div class="m-account--content">
                <h2 class="h2">Já trocou a senha?</h2>
                <p></p>
                <div @click="abrirLogin" class="btn">FAÇA LOGIN</div>
              </div>
            </div>
            <!-- Fim Textos Esqueci a Senha -->
          </div>

          <div class="col-md-6">
            <!-- Início Form Esqueci a Senha -->
            <div class="m-account--form-w">
              <div class="m-account--form">
                <!-- Início Logo -->
                <div class="logo">
                  <img src="../../assets/images/logo.png" alt="" />
                </div>
                <!-- Fim Logo -->

                <form>
                  <p class="m-account--title">Troque sua senha</p>

                  <p class="m-account--subtitle">
                    Informe sua nova senha e repita para poder fazer a troca
                  </p>

                  <div class="input-senha form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <i class="fas fa-key"></i>
                      </div>

                      <input-text
                        type="password"
                        name="novaSenha"
                        placeholder="Nova Senha"
                        autocomplete="off"
                        required
                        v-model="form.novaSenha"
                      />
                      <b-badge
                        v-if="deveConter6Caracteres"
                        :variant="deveConter6Caracteres.variant"
                      >
                        {{ deveConter6Caracteres.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterLetraMinuscula"
                        :variant="deveConterLetraMinuscula.variant"
                      >
                        {{ deveConterLetraMinuscula.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterLetraMaiuscula"
                        :variant="deveConterLetraMaiuscula.variant"
                      >
                        {{ deveConterLetraMaiuscula.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterCaracterEspecial"
                        :variant="deveConterCaracterEspecial.variant"
                      >
                        {{ deveConterCaracterEspecial.text }}
                      </b-badge>
                      <br />
                      <b-badge
                        v-if="deveConterNumero"
                        :variant="deveConterNumero.variant"
                      >
                        {{ deveConterNumero.text }}
                      </b-badge>
                    </div>
                  </div>

                  <div class="m-account--actions">
                    <b-button
                      :disabled="!form.novaSenha"
                      @click="resetarSenha"
                      class="btn btn-primary mx-auto"
                      >MUDAR A SENHA</b-button
                    >
                  </div>

                  <div class="m-account--footer">
                    <p>
                      Powered By <span><a href="#">Jordão Energia</a></span>
                    </p>
                  </div>
                </form>
              </div>
            </div>
            <!-- Fim Form Esqueci a Senha -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import InputText from "@/components/inputs/InputText";
import UsuarioService from "@/common/services/usuario/usuario.service";
import Swal from "sweetalert2";

export default {
  name: "ResetarSenha",
  components: {
    InputText,
  },
  data() {
    return {
      form: {
        novaSenha: null,
        token: null,
        usuarioId: null,
      },
    };
  },
  computed: {
    validarSenha() {
      if (!this.comparaSenha()) return false;
      return true;
    },
    senhaValida: function () {
      if (
        this.deveConter6Caracteres &&
        this.deveConter6Caracteres.variant == "success" &&
        this.deveConterLetraMaiuscula &&
        this.deveConterLetraMaiuscula.variant == "success" &&
        this.deveConterLetraMinuscula &&
        this.deveConterLetraMinuscula.variant == "success" &&
        this.deveConterCaracterEspecial &&
        this.deveConterCaracterEspecial.variant == "success" &&
        this.deveConterNumero &&
        this.deveConterNumero.variant == "success"
      )
        return true;
      return false;
    },
    deveConter6Caracteres: function () {
      if (!this.form.novaSenha) return null;
      if (this.form.novaSenha.length < 6)
        return {
          variant: "danger",
          text: "Deve conter no mínimo 6 caracteres",
        };
      return {
        variant: "success",
        text: "Deve conter no mínimo 6 caracteres",
      };
    },
    deveConterLetraMinuscula: function () {
      var letraMinuscula = /([a-z])/;
      if (!this.form.novaSenha) return null;
      if (this.form.novaSenha.match(letraMinuscula))
        return {
          variant: "success",
          text: "Deve conter letra minúscula",
        };
      return {
        variant: "danger",
        text: "Deve conter letra minúscula",
      };
    },
    deveConterLetraMaiuscula: function () {
      var letraMaiusculas = /([A-Z])/;
      if (!this.form.novaSenha) return null;
      if (this.form.novaSenha.match(letraMaiusculas))
        return {
          variant: "success",
          text: "Deve conter letra maiúsculas",
        };
      return {
        variant: "danger",
        text: "Deve conter letra maiúsculas",
      };
    },
    deveConterCaracterEspecial: function () {
      var chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<,.])/;
      if (!this.form.novaSenha) return null;
      if (this.form.novaSenha.match(chEspeciais))
        return {
          variant: "success",
          text: "Deve conter caractere especial",
        };
      return {
        variant: "danger",
        text: "Deve conter caractere especial",
      };
    },
    deveConterNumero: function () {
      var numeros = /([0-9])/;
      if (!this.form.novaSenha) return null;
      if (this.form.novaSenha.match(numeros))
        return {
          variant: "success",
          text: "Deve conter número",
        };
      return {
        variant: "danger",
        text: "Deve conter número",
      };
    },
  },
  methods: {
    abrirLogin() {
      this.$router.push({ name: "Login" });
    },
    validarFormulario() {
      let arValidation = [];
      arValidation.push(this.$refs.novaSenha.valid());

      return arValidation.filter((elem) => elem == false).length == 0;
    },
    resetarSenha() {
      // if (!this.validarFormulario()) return;
      if (!this.senhaValida) {
        this.alertaErro(
          "A senha não atende os requisitos mínimos de segurança"
        );
        return;
      }
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.$store.dispatch(START_LOADING);
      let form = this.form;
      form.token = urlParams.get("token");
      form.usuarioId = urlParams.get("usuarioId");
      UsuarioService.resetarSenha(form)
        .then(() => {
          Swal.fire({
            title: this.$t("GERAL.SUCCESSO"),
            text: this.$t("GERAL.SENHA_ALTERADA"),
            icon: "success",
            confirmButtonText: this.$t("GERAL.OK"),
          }).then(() => {
            this.$router.push({ name: "Login" });
          });
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    comparaSenha() {
      if (this.form.novaSenha !== this.form.novaSenha) {
        return false;
      }
      return true;
    },
    voltarLogin() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
<style>
.input-senha .col-form-label {
  padding-bottom: 0px;
}
</style>
